import React from "react";
import { Table } from "../UI/Table";
import UserListFilters from "./UserListFilters";
import { StyledRightContainer } from "../Projects/styles"; 
import { translate } from "../../utils/translations/translate";
import { useAccountList } from "./utils/hooks/useAccountList";
import { Alert } from "../UI/Alert";
import { Loader } from "../Loader/Loader";
import UserDeleteConfirmationModal from "./UserDeleteConfirmationModal";
const UsersList = () => {
  const {
    isError,
    isLoading,
    list,
    columnDefs,
    handlePaginationChange,
    pageNumber,
    pageSize,
    resourceKey,
    resourceType,
    setResourceKey,
    setResourceType,
    setStatusKey,
    statusKey,
    totalRecords,
    selectedList,
    updateSelectedList,
    bulkUpdateStatus,
    isPageBusy,
    toastInfo,
    showDeleteModal,
    setShowDeleteModal,
    bulkDeleteUsers,
    handleToastClose,
    hideServiceError
  } = useAccountList();
  const handlePopuOptionSelect = (key)=>{
    if(selectedList.length === 0) return;
    
    if(key==="Active" || key==="Inactive"){
      const selectedIds = selectedList.filter(listItem=>listItem.data.resourceStatus!==key).map(rsrc=>rsrc.id);
      bulkUpdateStatus(selectedIds,key);
    }
    else if(key==="Delete"){
      setShowDeleteModal(true);
    }
  }
  return (
    <StyledRightContainer>
      {isError && (
        <Alert  type="error" message={translate("labels.errorFetchingUsers")} onToastClose={hideServiceError}/>
      )}
      {toastInfo && <Alert  type={toastInfo.severity} message={toastInfo.message} onToastClose={handleToastClose} />}
      <h1>{translate("pageTitles.userManagement")}</h1>
      <UserListFilters
        resourceKey={resourceKey}
        resourceType={resourceType}
        setResourceKey={setResourceKey}
        setResourceType={setResourceType}
        setStatusKey={setStatusKey}
        statusKey={statusKey}
        onPopupOptionSelect={handlePopuOptionSelect}
        selectedRows={selectedList}
      />
      <div className="tma__table-container projectList">
        <Table
          columns={columnDefs}
          rowData={list}
          loading={isLoading}
          totalRecords={totalRecords}
          onPaginationChange={handlePaginationChange}
          currentPage={pageNumber}
          pageSize={pageSize}
          showPagination={true}
          onRowSelected={({ node }) => {
            const { data } = node;
            const selected = node.isSelected();
            const id = data.resourceId;
            updateSelectedList({ id, selected,data });
          }}
          isRowSelectable={(rowNode) =>
            rowNode.data.isEditable ? true : false
          }
        />
      </div>
      {isPageBusy && <Loader />}
      {showDeleteModal && <UserDeleteConfirmationModal onConfirm={bulkDeleteUsers} onClose={()=>{
        setShowDeleteModal(false);
      }} />}
    </StyledRightContainer>
  );
};

export default UsersList;
